// update state
const setActionTabs = (payload) => {
    return {
        type: "ACTIONTABS",
        payload
    }
}

export default setActionTabs;


// WEBPACK FOOTER //
// ./src/actions/setActionTabs.js